interface Meeting {
  day: string;
  id: string;
  month: string;
  status: string;
  time: string;
}

interface IMentoringListItem {
  item: Meeting;
  index: number;
  meetingStatus: string;
  statusClass: string;
  openPopup: () => void;
}

interface MeetingStatuses {
  id: number;
  name: string;
}

enum StyleClasses {
  GREEN = 'item__status_green',
  RED = 'item__status_red',
}

export { Meeting, IMentoringListItem, MeetingStatuses, StyleClasses };



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/programcard/components/main/components/list/components/item/types.ts